export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/38375a7b-bdfb-4b76-a7f1-81eb16766191.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/02aab002-dc46-4774-9145-a062cd523421.png',
};
